import { Currency } from 'src/services/apollo/generated/graphql'

export const SUPPORTED_LOCALES = {
  // ar: { code: 'ar', label: 'اَلْعَرَبِيَّةُ', currency: Currency.Usd },
  ja: { code: 'ja', label: '日本語', currency: Currency.Jpy },
  en: { code: 'en', label: 'English', currency: Currency.Usd },
  ko: { code: 'ko', label: '한국어', currency: Currency.Usd },
  zh: { code: 'zh', label: '繁體中文', currency: Currency.Usd },
  id: { code: 'id', label: 'Bahasa Indonesia', currency: Currency.Usd },
  de: { code: 'de', label: 'Deutsch', currency: Currency.Usd },
  fr: { code: 'fr', label: 'Français', currency: Currency.Usd },
  th: { code: 'th', label: 'ภาษาไทย', currency: Currency.Usd },
  vi: { code: 'vi', label: 'Tiếng Việt', currency: Currency.Usd },
  it: { code: 'it', label: 'Italiano', currency: Currency.Usd },
  uk: { code: 'uk', label: 'українська мова', currency: Currency.Usd },
  pl: { code: 'pl', label: 'Polski', currency: Currency.Usd },
  es: { code: 'es', label: 'Español', currency: Currency.Usd },
  ms: { code: 'ms', label: 'Bahasa Melayu', currency: Currency.Usd },
  tr: { code: 'tr', label: 'Türkçe', currency: Currency.Usd },
  pt: { code: 'pt', label: 'Português', currency: Currency.Usd },
} as const

export type SupportedLocaleCodes = keyof typeof SUPPORTED_LOCALES

// Locale alias mapping.
// Currently we want `kr` to behave as `ko`.
export const LOCALE_ALIASES = {
  kr: 'ko',
} satisfies Record<string, SupportedLocaleCodes>

export type LocaleAliasCodes = keyof typeof LOCALE_ALIASES

export type KnownLocaleCodes = LocaleAliasCodes | SupportedLocaleCodes

export const DEFAULT_LOCALE: SupportedLocaleCodes = 'en'

export const LOCALE_COOKIE_KEY = 'locale'

// Derived constants for runtime use
/** Array of supported locale codes (e.g., ['de', 'en', 'es', ...]) */
export const SUPPORTED_LOCALE_CODES = Object.keys(
  SUPPORTED_LOCALES,
) as SupportedLocaleCodes[]

/** Array of locale alias codes (e.g., ['kr']) */
export const ALIAS_LOCALE_CODES = Object.keys(
  LOCALE_ALIASES,
) as LocaleAliasCodes[]

/** Combined array of all known locale codes (supported + aliases), sorted */
export const LOCALE_CODES = [
  ...SUPPORTED_LOCALE_CODES,
  ...ALIAS_LOCALE_CODES,
].sort() as readonly KnownLocaleCodes[]
